module.exports = __webpack_public_path__ + "img/logo-igdb.1995e267.svg";